// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0_postcss@8.4.41_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0_postcss@8.4.41_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sc-table-select__table[data-v-1c9c541d] {\r\n  padding: 12px;\n}\n.sc-table-select__page[data-v-1c9c541d] {\r\n  padding-top: 12px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
